import styled, { keyframes } from 'styled-components';
import ButtonComponent from '@prisjakt/ui-button';
import { colors, layout, media } from '@prisjakt/ui-base';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Button = styled(ButtonComponent)`
  width: 100%;
`;

export const ReportOverlay = styled.div`
  color: ${p => p.theme.text.secondary};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 250ms ease-in-out 1;
`;

export const ToggleButtons = styled.button`
  color: ${p => p.theme.text.callToAction};
  text-decoration: underline;
  margin-left: 5px;
  cursor: pointer;
  color: ${colors.red1};
  white-space: nowrap;
  font-weight: 600;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const CloseButton = styled(ButtonComponent)`
  margin-left: ${layout.spacing.xSmall};
  flex-shrink: 0;
`;

export const PromptTitle = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: center;
  color: ${p => p.theme.text.tertiary};
  font-size: ${layout.fontSizes.small.mobile.rem};

  ${media.mediumUp`
    flex-direction: row;
    justify-content: center;
  `}
`;
